/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"

import Header from "./header/header"
import "../sass/styles.scss"
import Footer from "./footer"
import { PromoContext } from "../context/promoContext"
import { useStaticQuery, graphql } from "gatsby"

const Layout = ({ children }) => {
  let { updatePromos } = useContext(PromoContext)

  const data = useStaticQuery(
    graphql`
      query {
        allContentfulPromotion {
          edges {
            node {
              id
              active
              discount
              code
              skus
            }
          }
        }
      }
    `
  )

  let promos = data.allContentfulPromotion.edges
    .map(edge => edge.node)
    .filter(promo => !!promo.active)

  useEffect(() => {
    updatePromos(promos)
  }, [])

  return (
    <>
      <Header />
      <div id="page-content">
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
